
import { Button } from "@/components/ui/button";
import { Maximize2 } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CarouselControl } from "@/components/ui/carousel-control";

interface PostModalImageProps {
  imageUrl: string;
  title: string;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onMaximize: () => void;
}

export function PostModalImage({
  imageUrl,
  title,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onMaximize
}: PostModalImageProps) {
  return (
    <ScrollArea className="relative flex items-center justify-center bg-black/5 dark:bg-black/20 max-h-[100vh]">
      <div className="w-full relative">
        <img 
          src={imageUrl} 
          alt={title || "Imagem do post"} 
          className="w-full object-contain" 
        />
        
        <Button 
          variant="ghost" 
          size="icon" 
          className="absolute top-4 right-4 z-10 bg-white/50 hover:bg-white/80 dark:bg-black/50 dark:hover:bg-black/80 backdrop-blur-sm" 
          onClick={onMaximize}
        >
          <Maximize2 className="h-5 w-5 text-gray-700 dark:text-gray-200" />
        </Button>
      </div>
      
      <div className="absolute inset-y-0 left-0 flex items-center pl-4">
        {hasPrevious && (
          <CarouselControl
            type="previous"
            title="Post anterior"
            handleClick={onPrevious}
            disabled={!hasPrevious}
          />
        )}
      </div>
      
      <div className="absolute inset-y-0 right-0 flex items-center pr-4">
        {hasNext && (
          <CarouselControl
            type="next"
            title="Próximo post"
            handleClick={onNext}
            disabled={!hasNext}
          />
        )}
      </div>
    </ScrollArea>
  );
}
